<template>
<modal-dialog title="Your Referral Link" 
	:modal-visible="visible"
	:submit-visible="false"
	modal-size="modal-lg"
	cancel-button-text="Done"
	v-on:closeModal="$emit('closeModal')">

	<referral-link-banner></referral-link-banner>

	<div class="card mb-4">
		<div class="card-body">
			<h4 class="text-center">Choose where to share</h4>

			<div class="d-flex flex-wrap">

				<button class="share-button" v-on:click="shareBy('copy')">
					<div class="share-icon-wrapper"><i class="fa fa-copy fa-2x"></i></div>
					Copy
				</button>

				<button class="share-button" v-on:click="shareBy('qrcode')">
					<div class="share-icon-wrapper"><i class="fa fa-qrcode fa-2x"></i></div>
					QR Code
				</button>

				<button class="share-button" v-on:click="shareBy('email')">
					<div class="share-icon-wrapper"><i class="fa fa-envelope fa-2x"></i></div>
					Email
				</button>

				<button class="share-button" v-on:click="shareBy('linkedin')">
					<div class="share-icon-wrapper"><i class="fab fa-linkedin fa-2x"></i></div>
					Linkedin
				</button>

				<!--
				<button class="share-button" v-on:click="shareBy('insta')">
					<div class="share-icon-wrapper"><i class="fab fa-instagram fa-2x"></i></div>
					Instagram
				</button>
				-->

				<button class="share-button" v-on:click="shareBy('facebook')">
					<div class="share-icon-wrapper"><i class="fab fa-facebook fa-2x"></i></div>
					Facebook
				</button>

				<button class="share-button" v-on:click="shareBy('twitter')">
					<div class="share-icon-wrapper"><i class="fab fa-twitter fa-2x"></i></div>
					Twitter
				</button>

			</div>
		</div>
	</div>

	<div  v-if="showQrCode" class="text-center">
		<vue-qr-code style="display: inline-block;"
			:params="{text: userReferralLink}"
			:hide-buttons="true">
		</vue-qr-code>
	</div>

	<div class="d-flex flex-row">

		<div style="flex-grow: 1">
			<field
				:value="userReferralLink">
			</field>
		</div>
		<div style="align-self: flex-end;margin-bottom: 0.3rem">
			<button class="btn btn-light btn-attached" type="button" title="Copy link to clipboard" v-on:click="copyToClipboard(userReferralLink,'Link copied to clipboard')">
				<i class="fa fa-copy"></i>
			</button>
		</div>

	</div>
		
</modal-dialog>
</template>
<script type="text/javascript">
import VueQrCode from "@/components/VueQrCode"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import ReferralLinkBanner from "@/components/banner_ads/ReferralLinkBanner"
	
export default {
	name: "ReferralLinkModal",
	components: {
		VueQrCode,
		ModalDialog,
		Field,
		ReferralLinkBanner
	},
	props: ["visible"],
	data() {
		return {
			showQrCode: false
		}
	},
	computed: {
		userReferralLink() {
			return "https://tradetraks.ca?referral=user-"+this.$store.userDetails.slug
		},
		escapedUserReferralLink() {
			return "https://tradetraks.ca%3Freferral%3Duser-"+this.$store.userDetails.slug
		}
	},
	methods: {
		shareBy(method) {
			this.showQrCode = false

			let shareText = "Hey check this out: "+this.userReferralLink

			if (method == 'qrcode') {
				this.$nextTick(() => {
					this.showQrCode = true
				})
			}
			else if (method == 'copy')
				this.copyToClipboard(this.userReferralLink,true)
			else if (method == 'email') {
				shareText = "Hey check this out: "+this.escapedUserReferralLink
				window.open("mailto:&subject=Tradetraks is Awesome&body="+shareText,"_blank")
			}
			else if (method == 'linkedin') {
				window.open("https://www.linkedin.com/sharing/share-offsite/?url="+this.escapedUserReferralLink,"_blank")
			}
			else if (method == 'insta') {

			}
			else if (method == 'twitter') {
				window.open("https://twitter.com/intent/tweet?url="+this.userReferralLink,"_blank")
			}
			else if (method == 'facebook') {
				window.open("https://www.facebook.com/sharer/sharer.php?u="+this.userReferralLink,"_blank")
			}
		}
	}
}
</script>

<style scoped>

	.share-button {
		background-color: transparent;
		border: none;
		color: gray;
		flex-grow: 1;
		text-align: center;
	}

	.share-icon-wrapper {
		background-color: var(--brand-primary-color);
		height: 50px;
		width: 50px;
		border-radius: 50%;
		color: white;
		text-align: center;
		padding: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		margin: auto;
	}
</style>